export default __webpack_public_path__ + "static/media/August_03.2520ee11.png";